import { ENV } from '@/infrastructure/env-config';
import { FilterOptions } from '@/proto/alert';

export const ALERT_CHANNELS_OPTIONS: FilterOptions[] = [
  { value: 0, label: '所有' },
  { value: 1, label: '邮件' },
  { value: 2, label: '短信' },
  { value: 3, label: '电话' },
  { value: 4, label: '企业微信' },
];

export const ALERT_CHANNELS_OPTIONS_PRO: FilterOptions[] = [
  { value: 0, label: '所有' },
  { value: 1, label: '电子邮箱' },
  { value: 4, label: '微信公众号', hidden: ENV.isGlobal },
];
